<template>
  <base-modal size="5xl" ref="modal">
    <base-card shadow no-padding>
      <div v-if="isDetailsLoading === true">
        <div class="tw-flex tw-w-full tw-justify-between tw-bg-gray-100 tw-rounded-md">
          <div class="tw-pl-3.5 tw-pt-3.5 tw-pb-3 tw-w-full">
            <base-skeleton-loader class="tw-h-6 tw-w-1/4" />
          </div>
          <base-icon class="tw-mr-6 tw-my-auto sm:tw-mr-1.5 sm:tw-mt-1.5"><x-icon class="tw-h-8 tw-w-8 tw-rounded-full"/></base-icon>
        </div>
        <div class="tw-bg-gray-100 tw-px-3.5 tw-pt-2">
          <base-card>
            <div class="tw-flex tw-flex-col">
              <div class="tw-flex-auto tw-mb-3">
                <base-skeleton-loader class="tw-h-3 tw-w-28" />
              </div>
              <div class="tw-flex-auto">
                <base-skeleton-loader class="tw-h-2 tw-w-24" />
              </div>
              <div class="tw-flex tw-my-3">
                <base-skeleton-loader class="tw-h-2 tw-w-3 tw-mr-1" />
                <base-skeleton-loader class="tw-h-2 tw-w-6" />
              </div>
            </div>
          </base-card>
        </div>
      </div>
      <div v-else>
        <div class="tw-flex tw-w-full tw-justify-between tw-bg-gray-100 tw-rounded-md">
          <div class="tw-pl-3.5 tw-pt-3.5 tw-pb-3">
            <div class="tw-text-gray-700 tw-text-lg">
              {{ todoItem.todoItemTypeLabel }}
            </div>
          </div>
          <base-icon @click="hide" class="tw-mr-6 tw-my-auto sm:tw-mr-1.5 sm:tw-mt-1.5"><x-icon class="tw-h-8 tw-w-8 tw-rounded-full"/></base-icon>
        </div>
        <div class="tw-bg-gray-100 tw-px-3.5 tw-pt-2 tw-pb-2" v-if="Object.keys(member).length > 0">
          <base-card :shadow="true">
            <div class="tw-flex tw-flex-col">
              <div class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-mb-3">Member Details</div>
              <div class="tw-grid tw-grid-cols-3">
                <div class="tw-flex-auto">
                  <base-button type="text" size="md" @click="gotoMember(member.data.userId)">{{ member.data.fullName }}</base-button>
                  <div>
                    <span class="tw-text-xs tw-text-gray-700 tw-mr-1">DOB</span>
                    <span class="tw-text-xs tw-text-gray-500">{{ dobFormat(member.data.dob) }}</span>
                  </div>
                </div>
                <div>
                  <div class="tw-text-sm tw-text-gray-700 tw-mr-1 tw-mb-2">Prescriptions</div>
                  <div v-for="prescription in prescriptions.data" :key="prescription.id">
                    <div class="tw-text-xs tw-text-gray-500 tw-mb-1">{{ prescription.businessProgram.name }}</div>
                  </div>
                </div>
                <div>
                  <div class="tw-text-sm tw-text-gray-700 tw-mr-1 tw-mb-2">Plans</div>
                  <div v-for="plan in plans.data" :key="plan.id">
                    <div class="tw-text-xs tw-text-gray-500 tw-mb-1">{{ plan.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </base-card>
        </div>
      </div>
      <timeline :items="events" :isLoading="isHistoryLoading" />
    </base-card>
  </base-modal>
</template>

<script>
import moment from "moment";
import Timeline from "@/components/Timeline/Timeline";
import { XIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";

export default {
  name: "ViewDetails",
  props: {
    businessId: String,
  },
  components: { Timeline, XIcon },
  data() {
    return {
      isHistoryLoading: false,
      isDetailsLoading: false,
      todoItemId: null,
      events: [],
      todoItem: {},
      member: {},
      plans: [],
      prescriptions: [],
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    showPrescriptions() {
      if (this.organization.usePrescriptionProgramSetting === true && this.prescriptions.length > 0) return true;
      else return false;
    },
  },
  methods: {
    reset() {
      this.todoItemId = null;
      this.member = {};
      this.plans = [];
      this.prescriptions = [];
    },
    async show(item) {
      this.todoItemId = item.todoItemId;
      this.$refs.modal.show();
      await this.loadDetails(item);
      this.loadHistory();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    async loadDetails(item) {
      this.isDetailsLoading = true;

      this.$axios
        .get(`/businesses/${this.businessId}/todo/${item.todoItemId}?archived=${item.isDeleted}`)
        .then(async (res) => {
          this.todoItem = res.data;
          if (res.data.todoItemTypeTarget === "member") {
            [this.member, this.prescriptions, this.plans] = await Promise.all([
              this.$axios.get(`/businesses/${this.businessId}/members/${res.data.targetEntityId}`),
              this.$axios.get(`/businesses/${this.businessId}/members/${res.data.targetEntityId}/prescriptions`),
              this.$axios.get(`/businesses/${this.businessId}/members/${res.data.targetEntityId}/memberplans`),
            ]);
            /*   await this.loadMemberData(res.data.targetEntityId);
            await this.loadPrescriptions(res.data.targetEntityId);
            await this.loadPlans(res.data.targetEntityId); */
          }
        })
        .finally(() => {
          this.isDetailsLoading = false;
        });
    },
    loadHistory() {
      this.isHistoryLoading = true;

      this.$axios
        .get(`/businesses/${this.businessId}/todo/${this.todoItemId}/history`)
        .then((res) => {
          this.events = this.transformData(res.data);
        })
        .finally(() => {
          this.isHistoryLoading = false;
        });
    },
    async loadMemberData(memberId) {
      await this.$axios.get(`/businesses/${this.businessId}/members/${memberId}`).then((res) => {
        this.member = res.data;
      });
    },
    async loadPrescriptions(memberId) {
      await this.$axios.get(`/businesses/${this.businessId}/members/${memberId}/prescriptions`).then((res) => {
        this.prescriptions = res.data;
      });
    },
    async loadPlans(memberId) {
      await this.$axios.get(`/businesses/${this.businessId}/members/${memberId}/memberplans`).then((res) => {
        this.plans = res.data;
      });
    },
    gotoMember(memberId) {
      if (this.organization.usePrescriptionProgramSetting) {
        this.$router.push(`/businesses/${this.businessId}/members/${memberId}/prescriptions`);
      } else {
        this.$router.push(`/businesses/${this.businessId}/members/${memberId}/plans`);
      }
    },
    dobFormat(dob) {
      return new moment.utc(dob).format("MM/DD/YYYY");
    },
    transformData(items) {
      var formattedItems = [];
      items.forEach((item) => {
        item.subheading = new moment.utc(item.insertDate).local().format("MMM DD h:mma");

        switch (item.type) {
          case "comment":
            item.orientation = "right";
            item.iconName = "comment";
            break;
          case "status":
            item.orientation = "left";
            item.iconName = "list";
            break;
          case "assigned":
            item.orientation = "left";
            item.iconName = "user";
            break;
          case "completed":
            item.orientation = "left";
            item.iconName = "check";
            break;
          default:
            item.orientation = "left";
            item.iconName = "list";
        }

        formattedItems.push(item);
      });

      // Ensure insertDate is parsed correctly
      return formattedItems.sort((a, b) => {
        const dateA = new Date(a.insertDate);
        const dateB = new Date(b.insertDate);
        return dateB - dateA;
      });
    },
  },
};
</script>
